import * as yup from 'yup'

import {Jurisdiction} from '@/utils/countries/constants'
import {BillingEntityType} from '@/utils/validations/common/billingEntity'
import {tmOwnershipTransferBodySchema} from '@/utils/validations/common/trademarkOwnershipTransfer'

export enum TrademarkOwnershipTransferPrefillSource {
  Pricing = 'pricing',
}

export type TmOwnershipTransferTrademarkDetails = {
  uuid?: string // client-generated, used as a stable React key across add/remove operations, stripped before saving
  jurisdiction: Jurisdiction
  registration_number: string
}

export type TrademarkOwnershipTransferFields = Omit<
  yup.InferType<typeof tmOwnershipTransferBodySchema>,
  'jurisdictions' | 'trademark_details' | 'note' | 'billing_entity' | 'files'
> & {
  jurisdictions: Jurisdiction[]
  trademark_details: TmOwnershipTransferTrademarkDetails[]
  note: string
  billing_entity: BillingEntityType
  files: File[]
}
